module.exports = __webpack_public_path__ + "static/media/img-evaluator@2x.c778d706.png";